import { ActionIcon, Container, Group, Text } from '@mantine/core';
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandTwitter,
} from '@sloyd/icons';
import styles from './Footer.module.css';
import { Wrapper } from './Footer.style';

export type FooterProps = {};

export function Footer(_props: FooterProps) {
  return (
    <Wrapper className='Footer-wrapper' data-testid='Footer-wrapper'>
      <div className={styles.footer}>
        <Container>
          <div className={styles.inner}>
            <div>
              <Text className={styles.logo}>Sloyd</Text>
              <Text size='sm' color='dimmed'>
                Revolutionizing 3D creation with AI-powered generators. Unlock your creativity with
                endless possibilities.
              </Text>
            </div>

            <Group gap='lg' className={styles.links}>
              <a href='/about' className={styles.link}>
                About Us
              </a>
              <a href='/features' className={styles.link}>
                Features
              </a>
              <a href='/pricing' className={styles.link}>
                Pricing
              </a>
              <a href='/support' className={styles.link}>
                Support
              </a>
            </Group>

            <Group gap='xs' className={styles.socialIcons}>
              <ActionIcon size='lg' variant='filled' color='blue'>
                <IconBrandFacebook size={20} />
              </ActionIcon>
              <ActionIcon size='lg' variant='filled' color='blue'>
                <IconBrandTwitter size={20} />
              </ActionIcon>
              <ActionIcon size='lg' variant='filled' color='blue'>
                <IconBrandInstagram size={20} />
              </ActionIcon>
              <ActionIcon size='lg' variant='filled' color='blue'>
                <IconBrandLinkedin size={20} />
              </ActionIcon>
            </Group>
          </div>

          <div className={styles.bottom}>
            <Text size='xs' color='dimmed'>
              © 2024 Sloyd. Empowering 3D creators everywhere.
            </Text>
          </div>
        </Container>
      </div>
    </Wrapper>
  );
}

export default Footer;
